import React from 'react';
import { PortalLink } from 'apps/client/components/PortalLink';

import { graphqlIdToDecimal } from 'utils/dgraphId';

// { rfqId: rfq.id }

export function makeDecimalIdLink({
  routeName,
  paramName,
  prefix = '',
}: {
  routeName: string;
  paramName: string;
  prefix?: string;
}) {
  return function DecimalIdLink(id: string) {
    if (!id) {
      return null;
    }
    const decimalId = graphqlIdToDecimal(id);
    const routeParams = { [paramName]: decimalId };

    let iconType: any = '';

    const iconTypeMap: { [key: string]: string } = {
      rfq: 'rfq',
      quote: 'quote',
      order: 'order',
    };

    iconType = iconTypeMap[routeName] || '';

    return (
      <PortalLink
        name={routeName}
        params={routeParams}
        openTab={{ title: `${decimalId}`, iconType }}
      >
        {prefix + decimalId}
      </PortalLink>
    );
  };
}
